import React from "react";

const siteLogo = `${process.env.PUBLIC_URL}/logo.png`;

const SiteLogo = () =>
{
    return (
      <img
        src={siteLogo}
        alt="Haseeb Sajjad"
        className="site-logo-img"
      />
    );
};

export default SiteLogo;
